// extracted by mini-css-extract-plugin
module.exports = {"close-button":"styles_close-button__bZPQI"};